'use strict';

angular.module('ClinicApp').directive('doctorInsurance', function(
  $q,
  DoctorService,
  InsuranceService,
  OCModalUtil,
  OCInsuranceUtil,
  OpencareConstants,
  CurrentUser,
  GrowlService,
) {
  return {
    scope: {
      doctor: '=doctorInsurance',
      setupMode: '=',
      content: '=',
      onSave: '&',
    },
    templateUrl: '/views/directives/_doctor-insurance.html',
    link: function($scope) {
      if (!angular.isArray($scope.doctor.insurancePlans)) {
        throw new Error('DirectiveArgumentError: `doctorInsurance` doctor insurance plans should be provided.');
      }

      var _$window = $(window);

      $scope.states = {
        loading: true,
        waiting: false,
      };

      // Providers Opencare manages are read-only for practice users.
      // Opencare staff, including staff impersonating this practice, keep full edit access.
      // Fixed for the lifetime of the directive, so it is not part of `states`.
      const areManagedProvidersLocked = OCInsuranceUtil.areManagedProvidersLocked($scope.doctor);

      $scope.managedInsuranceContactEmail = OpencareConstants.managedInsurance.contactEmail;

      $scope.userSelected = {
        insuranceProvider: null,
        insuranceProviderTypeahead: null,
        insurancePlan: null,
        insurancePlanTypeahead: null,
      };

      $scope.states.loading = true;
      loadInsuranceProviders($scope.doctor.specialties)
        .then(() => {
          syncDoctorInsurance();
          $scope.selectInsuranceProvider();

          // List doctors of the current user with populated insurance.
          // These doctors are used to copy insurance plans.
          var doctorIds = _.pluck(CurrentUser.getDoctors(), 'id');
          if (!doctorIds.length) {
            return [];
          }

          return DoctorService.getDoctor(doctorIds, {
            noReview: true,
            noSpecialties: true,
            noLanguages: true,
            noPotentialAppointmentTypes: true,
            noQuestionResponses: true,
            noProviders: true,
          });
        })
        .then((doctors) => {
        // Filter doctors with insurance plans that can be applyed (copied) for the current doctor.
        // ---
        // Detect insurance provider type supported by the current doctor.
          var insuranceProviderType = OpencareConstants.insuranceProviderType.MEDICAL;
          var doctorDentalSpecialty = _.find($scope.doctor.specialties || [], function(specialty) {
            return _.includes([
              OpencareConstants.specialtyId.DENTIST,
              OpencareConstants.specialtyId.ORTHODONTIST,
            ], parseInt(specialty.id, 10));
          });
          if (doctorDentalSpecialty) {
            insuranceProviderType = OpencareConstants.insuranceProviderType.DENTAL;
          }

          angular.forEach(doctors, function(doctor) {
          // Select insurance plans with supported provider type.
            doctor.insurancePlans = _.filter(doctor.insurancePlans, function(insurancePlan) {
              return insurancePlan.provider.type == insuranceProviderType;
            });
          });

          $scope.doctorsWithInsurance = _.filter(doctors, function(doctor) {
            return !_.isEmpty(doctor.insurancePlans);
          });
        })
        .finally(() => {
          $scope.states.loading = false;
        });

      function getInsuranceProviderContainerElement() {
        return $('#js-insurance-provider-edit-list');
      }

      function getInsuranceProviderElement(insuranceProvider) {
        var _$insuranceProviderEditList = getInsuranceProviderContainerElement();
        return _$insuranceProviderEditList.find('[data-id="' + insuranceProvider.id + '"]');
      }

      function scrollToInsuranceProvider(insuranceProvider) {
        var _$insuranceProviderEditList = getInsuranceProviderContainerElement();
        var _$insuranceProviderItem = getInsuranceProviderElement(insuranceProvider);
        if (_$insuranceProviderEditList.length && _$insuranceProviderItem.length) {
          _$insuranceProviderEditList.scrollTop(0);
          _$insuranceProviderEditList.scrollTop(_$insuranceProviderItem.position().top);
        }
      }

      $scope.$watch('userSelected.insuranceProviderTypeahead', function(insuranceProvider) {
        if (!angular.isObject(insuranceProvider)) {
          return;
        }

        $scope.userSelected.insuranceProviderTypeahead = null;

        if (!$scope.userSelected.insuranceProvider
          || $scope.userSelected.insuranceProvider.id != insuranceProvider.id
        ) {
          $scope.selectInsuranceProvider(insuranceProvider);
          scrollToInsuranceProvider(insuranceProvider);
        }
      });

      $scope.$watch('userSelected.insurancePlanTypeahead', function(insurancePlan) {
        if (!angular.isObject(insurancePlan)) {
          return;
        }

        var groupName = findGroupNameForPlan(insurancePlan);
        var group = _.find($scope.userSelected.insuranceProvider.planGroups, {
          name: groupName,
        });
        $scope.editPlans(group, insurancePlan);
        $scope.userSelected.insurancePlanTypeahead = null;
      });

      $scope.isSupported = function(insuranceItem) {
        return insuranceItem && insuranceItem.supported;
      };

      $scope.isProviderLocked = (insuranceProvider) =>
        areManagedProvidersLocked && OCInsuranceUtil.isManagedProvider(insuranceProvider);

      $scope.isSelectedProviderLocked = () => $scope.isProviderLocked($scope.userSelected.insuranceProvider);

      $scope.hasSupportedPlans = function(insuranceProvider) {
        return !!_.find(insuranceProvider.plans, {
          supported: true,
        });
      };

      $scope.selectInsuranceProvider = function(insuranceProvider) {
        if (!insuranceProvider && angular.isArray($scope.insuranceProviders)) {
          if (!$scope.doctor.insurancePlans.length) {
            var popularGroup = _.find($scope.insuranceProviderGroups, {
              name: insuranceProviderGroupLabels.popular,
            });
            insuranceProvider = popularGroup ? popularGroup.insuranceProviders[0] : $scope.insuranceProviders[0];
          } else {
            insuranceProvider = _.find($scope.insuranceProviders, {
              supported: true,
            });
          }
        }
        $scope.userSelected.insuranceProvider = insuranceProvider;
        $scope.userSelected.insuranceProviderTypeahead = null;

        // Scroll to the edit area on mobile devices.
        if (_$window.width() <= 767) {
          var _$insuranceProviderEditList = getInsuranceProviderContainerElement();
          if (_$insuranceProviderEditList.length && _$window.scrollTop() < _$insuranceProviderEditList.offset().top) {
            _$window.scrollTop(_$insuranceProviderEditList.offset().top);
          }
        }
      };

      $scope.countSupportedInsurancePlans = function(plans) {
        return _.filter(plans, {
          supported: true,
        }).length;
      };

      $scope.editPlans = function(group, selectedPlan) {
        const readOnly = $scope.isSelectedProviderLocked();
        var title = $scope.userSelected.insuranceProvider.name + ' ' + group.name + ' Plans';
        OCModalUtil.showCustomModal({
          windowClass: 'modal-insurance-plan-selector',
          templateUrl: '/views/modals/_insurance-plan-selector.html',
          controller: 'InsurancePlanSelector',
          resolve: OCModalUtil.createResolve({
            plans: group.plans,
            title,
            selectedPlan,
            readOnly,
          }),
        }).then(function(plans) {
          if (readOnly) {
            return;
          }
          group.plans = plans;
          onChangePlanSupported();
        });
      };

      $scope.toggleInsurancePlansSupport = function(plans, supported) {
        if ($scope.isSelectedProviderLocked()) {
          return;
        }
        angular.forEach(plans, function(insurancePlan) {
          insurancePlan.supported = !!supported;
        });
        onChangePlanSupported();
      };

      function updatePlanGroupsAllSupported() {
        _.each($scope.insuranceProviders, function(insuranceProvider) {
          _.each(insuranceProvider.planGroups, function(planGroup) {
            planGroup.allSupported = _.all(planGroup.plans, 'supported');
          });
        });
      }

      function onChangePlanSupported() {
        $scope.insuranceProviderGroups = getInsuranceProviderGroups($scope.insuranceProviders);
        updatePlanGroupsAllSupported();
        $scope.canSave = true;
      }

      var insuranceProviderGroupLabels = {
        inNetwork: 'In-Network Providers',
        popular: 'Popular Providers',
        all: 'Other Providers',
      };

      function insuranceProviderGroup(provider) {
        if ($scope.hasSupportedPlans(provider)) {
          return insuranceProviderGroupLabels.inNetwork;
        } else if (provider.isPopular) {
          return insuranceProviderGroupLabels.popular;
        } else {
          return insuranceProviderGroupLabels.all;
        }
      }

      function insuranceProviderGroupOrder(group) {
        return [
          insuranceProviderGroupLabels.inNetwork,
          insuranceProviderGroupLabels.popular,
          insuranceProviderGroupLabels.all,
        ].indexOf(group);
      }

      function getInsuranceProviderGroups(insuranceProviders) {
        return _.chain(insuranceProviders).groupBy(insuranceProviderGroup)
          .map(function(providers, groupName) {
            return {
              insuranceProviders: providers,
              name: groupName,
            };
          })
          .sortBy(function(group) {
            return insuranceProviderGroupOrder(group.name);
          })
          .value();
      }

      $scope.onToggleAllSupported = function(group) {
        if ($scope.isSelectedProviderLocked()) {
          // Put the checkbox back, practice users cannot change managed providers.
          group.allSupported = group.plans.every(({ supported }) => supported);
          return;
        }
        $scope.toggleInsurancePlansSupport(group.plans, group.allSupported);
      };

      $scope.copyInsurance = function() {
        if ($scope.isSelectedProviderLocked()) {
          return;
        }

        var _doctor = null;

        OCModalUtil.showCustomModal({
          windowClass: 'doctors-with-insurance-modal',
          templateUrl: '/views/modals/_doctors-with-insurance.html',
          controller: 'ModalDoctorsWithInsurance',
          resolve: OCModalUtil.createResolve({
            doctors: $scope.doctorsWithInsurance,
          }),
        }).then(function(doctor) {
          _doctor = doctor;

          // Check if user has specified any insurance plans for this doctor.
          var firstSupportedInsurancePlan = _.chain($scope.insuranceProviders).pluck('plans')
            .flatten()
            .find({
              supported: true,
            })
            .value();
          if (firstSupportedInsurancePlan) {
            return OCModalUtil.showModal(
              'confirm',
              `This will overwrite your existing plans for ${$scope.doctor.name}. Are you sure you want to continue?`,
            );
          }
        })
          .then(function() {
            syncDoctorInsurance(_doctor.insurancePlans);
          });
      };

      $scope.cancel = function() {
        // Revert back user changes.
        angular.forEach($scope.insuranceProviders, function(insuranceProvider) {
          insuranceProvider.supported = insuranceProvider.supportedInitially;

          angular.forEach(insuranceProvider.plans, function(insurancePlan) {
            insurancePlan.supported = insurancePlan.supportedInitially;
          });
        });
        onChangePlanSupported();
        $scope.canSave = false;
      };

      $scope.save = function() {
        $scope.states.waiting = true;

        var insurancePlanIds = [];
        var initialInsurancePlanIds = [];

        angular.forEach($scope.insuranceProviders, function(insuranceProvider) {
          angular.forEach(insuranceProvider.plans, function(insurancePlan) {
            if (insurancePlan.supported) {
              insurancePlanIds.push(insurancePlan.id);
            }
            if (insurancePlan.supportedInitially) {
              initialInsurancePlanIds.push(insurancePlan.id);
            }
          });
        });

        var changed = false;
        if (insurancePlanIds.length != initialInsurancePlanIds.length) {
          changed = true;
        } else {
          changed = _.intersection(insurancePlanIds, initialInsurancePlanIds).length != initialInsurancePlanIds.length;
        }

        return $q.when()
          .then(() => {
            if (changed && insurancePlanIds.length) {
              return OCModalUtil.showModal(
                'confirm',
                `Please confirm that ${$scope.doctor.name} is an <strong>in-plan provider</strong> for all plans specified.`,
              );
            }
          })
          .then(() => {
            if (changed) {
              return DoctorService.updateInsurancePlans($scope.doctor.id, insurancePlanIds);
            }
          })
          .then(() => {
            if (changed) {
              return DoctorService.getDoctor($scope.doctor.id);
            }
          })
          .then((doctor) => {
            if (doctor) {
              $scope.doctor = doctor;
              syncDoctorInsurance();
              $scope.$emit('reloadDoctor');
            }
            return $scope.onSave({
              insurancePlans: $scope.doctor.insurancePlans,
            });
          })
          .then(() => {
            $scope.canSave = false;
            if (!$scope.setupMode) {
              GrowlService.success('Insurance plans for ' + $scope.doctor.name + ' have been updated.');
            }
          })
          .finally(() => {
            $scope.states.waiting = false;
          });
      };

      function loadInsuranceProviders(specialties) {
        var specialtyIds = _.pluck(specialties, 'id');
        var region = _.chain($scope.doctor.providers).map('clinic.address.administrative_area_level_1_short')
          .first()
          .value();
        return InsuranceService.listInsuranceProviders(specialtyIds, region).then(function(insuranceProviders) {
          if (!angular.isArray(insuranceProviders) || !insuranceProviders.length) {
            throw new Error('Could not load list of insurance providers.');
          }
          $scope.insuranceProviders = _.chain(insuranceProviders).filter(function(insuranceProvider) {
            return angular.isArray(insuranceProvider.plans) && insuranceProvider.plans.length;
          })
            .sortBy('name')
            .value();
        });
      }

      function syncDoctorInsurance(insurancePlansToCopy) {
        var doctorInsurancePlans = null;
        var copy = false;

        if (angular.isArray(insurancePlansToCopy)) {
          copy = true;
          doctorInsurancePlans = insurancePlansToCopy;
        } else {
          doctorInsurancePlans = $scope.doctor.insurancePlans;
        }

        var doctorInsuranceProviderIds = _.chain(doctorInsurancePlans).pluck('provider')
          .pluck('id')
          .value();
        var doctorInsurancePlanIds = _.pluck(doctorInsurancePlans, 'id');

        // Mark doctor supported insurance providers and plans.
        angular.forEach($scope.insuranceProviders, function(insuranceProvider) {
          // Copying another provider's insurance must leave managed providers as they are.
          if (copy && $scope.isProviderLocked(insuranceProvider)) {
            return;
          }

          var supportedInsuranceProvider = doctorInsuranceProviderIds.indexOf(insuranceProvider.id) !== -1;
          insuranceProvider.supported = supportedInsuranceProvider;
          if (!copy) {
            insuranceProvider.supportedInitially = supportedInsuranceProvider;
          }

          angular.forEach(insuranceProvider.plans, function(insurancePlan) {
            var supportedInsurancePlan = doctorInsurancePlanIds.indexOf(insurancePlan.id) !== -1;
            insurancePlan.supported = supportedInsurancePlan;
            if (!copy) {
              insurancePlan.supportedInitially = supportedInsurancePlan;
            }
          });
        });

        if (copy) {
          onChangePlanSupported();
        } else {
          $scope.insuranceProviderGroups = getInsuranceProviderGroups($scope.insuranceProviders);
          setInsurancePlanGroups();
        }
      }

      // Order of this array is the display order of the groups in the UI
      var insuranceCategoryGroups = [{
        name: 'PPO',
        types: ['PPO', 'PDP', 'PDN', 'DPPO', 'POS'],
      }, {
        name: 'HMO',
        types: ['HMO', 'DMO', 'EPO'],
      }, {
        name: 'Social Aid',
        types: ['Social Aid', 'CHIP', 'ICP'],
      }, {
        name: 'Traditional',
        types: ['Traditional', 'Indemnity', 'HSA', 'Unrestricted'],
      }, {
        name: 'Federal (FEP)',
        types: ['FEP', 'Military'],
      }, {
        name: 'Other',
        types: [],
      }];

      function findGroupNameForPlan(plan) {
        var planCategories = _.map(plan.categories, 'nameShort');
        if (!planCategories.length) {
          return 'Other';
        }

        var group = _.find(insuranceCategoryGroups, function(group) {
          return _.intersection(group.types, planCategories).length;
        });
        return group.name || 'Other';
      }

      //
      // Sort the plans into groups based on their category
      // Returns an array of objects with keys {plans, name, allSupported}
      //
      function setInsurancePlanGroups() {
        _.each($scope.insuranceProviders, function(insuranceProvider) {
          var planGroups = {};

          _.each(insuranceProvider.plans, function(plan) {
            var groupName = findGroupNameForPlan(plan);
            planGroups[groupName] = planGroups[groupName] || [];
            planGroups[groupName].push(plan);
          });

          insuranceProvider.planGroups = _.chain(planGroups).map(function(plans, groupName) {
            return {
              plans: plans,
              name: groupName,
              allSupported: _.all(plans, 'supported'),
            };
          })
            .sortBy(function(group) {
              return _.findIndex(insuranceCategoryGroups, {
                name: group.name,
              });
            })
            .value();
        });
      }
    },
  };
});
